import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography } from '@mui/material';
import './ResetPassword.css';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AUTH_APP_VERSION, AUTH_LEGAL_NOTICE } from '../constants/authMeta';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{6,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordRegex.test(newPassword)) {
      setError('Password must be at least 6 characters and include uppercase, lowercase, number, and special character.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/reset-password`,
        { token, newPassword }
      );
      setMessage(res.data.message || 'Password changed successfully. You can now log in.');
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (error) {
      console.error('Error resetting password:', error);
      setError(error.response?.data?.message || 'Error resetting password.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <div className="login-left">
          <div className="login-left-inner">
            <img src="/logo_white.png" alt="EXREG" className="login-brand-logo" />
            <Typography className="login-brand-subtitle">
              Hazardous Area Equipment Register & Inspection Platform
            </Typography>

            <ul className="login-highlights">
              <li>Set a strong password to protect your register</li>
              <li>Password rules are enforced automatically</li>
              <li>You’ll be redirected to login after success</li>
            </ul>

            <div className="login-left-badges">
              <span className="login-badge">Secure</span>
              <span className="login-badge">Account</span>
              <span className="login-badge">Recovery</span>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-box">
            <Typography className="login-title">Reset password</Typography>
            <Typography className="login-subtitle">
              Choose a new password for your account.
            </Typography>

            <form onSubmit={handleSubmit} className="login-form">
              <TextField
                fullWidth
                label="New Password"
                margin="normal"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                helperText="At least 6 characters, with uppercase, lowercase, number, and special character."
              />
              <TextField
                fullWidth
                label="Confirm Password"
                margin="normal"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />

              {error && (
                <Typography className="login-message error">
                  {error}
                </Typography>
              )}

              {message && (
                <Typography className="login-message success">
                  {message}
                </Typography>
              )}

              <Button type="submit" variant="contained" fullWidth className="login-primary-btn">
                Reset Password
              </Button>

              <Button
                variant="text"
                color="secondary"
                fullWidth
                className="login-forgot-btn"
                onClick={() => navigate('/login')}
              >
                Back to login
              </Button>
            </form>

            <div
              className="login-meta"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
            >
              <Typography variant="caption" className="login-version" style={{ textAlign: 'center' }}>
                {AUTH_APP_VERSION}
              </Typography>
              <Typography variant="caption" className="login-legal" style={{ textAlign: 'center' }}>
                {AUTH_LEGAL_NOTICE}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
